import { IdTitle, IIdTitle } from "ui/Scripts/source/models/common/idTitle";
import { ApplicationPermissionType } from "ui/Scripts/source/models/enums";

export interface ISavedListFilter extends IIdTitle {
    applicationPermissionType: ApplicationPermissionType;
    generalFilter: any;
    sortOrder: number;
    sortColumn: string;
    sortOrderIsAsc: boolean;

    getHash(): string;
}

export class SavedListFilter extends IdTitle implements ISavedListFilter {
    applicationPermissionType: number;
    generalFilter: any;
    sortOrder: number;
    sortColumn: string;
    sortOrderIsAsc: boolean;

    constructor();
    constructor(obj: ISavedListFilter);
    constructor(obj?: any) {
        super(obj);
        this.applicationPermissionType = obj && obj.applicationPermissionType || ApplicationPermissionType.Message;
        this.sortOrder = obj && obj.sortOrder || 0;
        this.sortColumn = obj && obj.sortColumn || "";
        this.sortOrderIsAsc = obj && obj.sortOrderIsAsc || false;
        this.generalFilter = {};
        if (obj && obj.generalFilter) {
            this.generalFilter = obj.generalFilter;
        }
    }

    getHash(): string {
        return super.getHash() + "#" + this.applicationPermissionType.toString(10) + "#" + this.sortColumn + "#" + this.sortOrderIsAsc.toString() + "#" + JSON.stringify(this.generalFilter);
    }
}